// Mounts Hanko's <hanko-auth> web component into every element with
// `data-hanko-login` on the page. The element's data attributes carry the
// runtime config:
//
//   data-hanko-api-url         Hanko project base URL (from settings.hanko_api_url)
//   data-hanko-callback-url    Where to navigate once Hanko fires onSessionCreated
//   data-hanko-prefilled-email Optional email to prefill (set from invite links)
//   data-hanko-mode            Optional "login" or "registration" to force a flow
//
// There's no identifier-first / legacy fallback - clinics are all on Hanko, so
// the email form has been replaced by the widget itself.

import { register, Hanko } from "@teamhanko/hanko-elements";
import { en } from "@teamhanko/hanko-elements/i18n/en";
import { registerFlowTracking } from "./hanko_flow_tracking.js";

async function mountHankoAuth(target) {
  const apiUrl = target.dataset.hankoApiUrl;
  const callbackUrl = target.dataset.hankoCallbackUrl;
  const prefilledEmail = target.dataset.hankoPrefilledEmail;
  const mode = target.dataset.hankoMode;
  if (!apiUrl) throw new Error("data-hanko-api-url is required on the Hanko mount target");

  // custom text strings
  en.headlines.loginEmailNoSignup = "Welcome back";
  en.headlines.signIn = "Welcome back";
  en.flowErrors.unknown_email_error = "This email is not yet registered with us. Please create a new account first.";
  en.headlines.registerPassword = "Enter a password";
  en.texts.otpLogin = "Open your authenticator app to obtain the one-time password (OTP). Enter the code in the field below to complete your login. Having issues logging in? Contact support@ovrcome.io";

  await register(apiUrl, { translations: { en } });

  const hanko = new Hanko(apiUrl);
  registerFlowTracking(hanko);
  hanko.onSessionCreated(() => {
    window.location.assign(callbackUrl);
  });

  // Build the element through the DOM (not innerHTML) so the email coming from the
  // query string can't be used for markup injection.
  const authElement = document.createElement("hanko-auth");
  if (prefilledEmail) authElement.setAttribute("prefilled-email", prefilledEmail);
  if (mode) authElement.setAttribute("mode", mode);
  target.replaceChildren(authElement);
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-hanko-login]").forEach((target) => {
    mountHankoAuth(target).catch((error) => {
      console.error("Failed to mount Hanko auth element", error);
    });
  });
});
